// Sentry instrumentation — imported first in index.tsx so error/performance
// tracking is active before the rest of the app mounts.
//
// Docs: https://docs.sentry.io/platforms/javascript/guides/react/
import * as Sentry from '@sentry/react';

const dsn = process.env.REACT_APP_SENTRY_DSN;

if (dsn) {
  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV || 'production',
    integrations: [Sentry.browserTracingIntegration()],
    // Sample a slice of transactions/sessions rather than 100%, to stay
    // well within free-tier volume.
    tracesSampleRate: 0.2,
    // Explicit Sentry.setUser() is called from AuthContext on login/logout —
    // no need for automatic session-wide PII collection here.
  });
} else {
  // eslint-disable-next-line no-console
  console.log('ℹ️  REACT_APP_SENTRY_DSN not set — Sentry disabled');
}
